import { PurchaseOrderProducts } from '@/features/purchase-order/purchase-order-products';

export function PurchaseOrderProductsPage() {
  return <PurchaseOrderProducts />;
}
